import React, { Component } from 'react'

import { Card } from '@myxplor/ui'

import ActiveFilter, { Toggles as ActiveFilterToggles } from '../ui/active-filter'
import DefaultForm from '../ui/forms/default-form'
import List from '../ui/list'
import LocalAsyncStore from '../local-async-store'
import NavigateByWeek from '../ui/navigate-by-week'
import NoSubmissions from './views/empty'
import SessionSummariesList from './views'
import SessionSummary from './details'
import ForceSyncButton from './views/force-sync-button'
import { RegHolderName } from '../layout'
import { dayFormat } from '../week'
import { recordActionsToDisplay } from '../ui/gov-actions'
import { FormTextArea } from '@myxplor/forms'
import { Note } from '@myxplor/ui'
import { hasAvailableAction } from '../ui/gov-actions'
import { getRegHolder } from '../reg-holder'
import ExpiryMessage from '../ui/expiry-message'
import moment from 'moment'

import './styles.css'

export const apiEndPoint = ({ record_type, id, start_date }) =>
  `/api/${record_type}/${id}/session-summaries?week=${dayFormat(start_date)}`

export const activeChild = ({ child_active }) => child_active

const filterShape = record => {
  const { first_name, last_name } = record.child

  return {
    name: [first_name, last_name].join(' '),
    last_name,
  }
}

const formValue = 'submission_for_week'

const actionsForRecord = ({ refresh_child_submissions, start_date, service_id }) => () => [
  {
    label: 'Submissions for Week',
    value: formValue,
    actionForm: ({ handleSuccess }) => (
      <DefaultForm
        url={
          process.env.REACT_APP_API_HOST +
          `/api/services/${service_id}/session-reports/submit-for-week`
        }
        value={formValue}
        label="Submissions for Week"
        formOptions={{
          defaultValues: {
            week_start: dayFormat(start_date),
            late_submission_reason: undefined,
          },
        }}
        formComponent={({ values, errors, onChange }) => (
          <fieldset>
            <legend>Submit all session reports for this week</legend>
            <Note important>
              If you are creating a new submission after the 14-day limit or are updating a submission
              after the 28-day limit, you will need to provide a reason for the late change for
              assessment by the Department of Education and Training.
              <FormTextArea
                name="late_submission_reason"
                label="Late Submission Reason"
                value={values.late_submission_reason}
                errors={errors.late_submission_reason}
                onChange={onChange}
                maxLength={1000}
                rows={2}
              />
            </Note>
          </fieldset>
        )}
        loadingTitle="Submitting for week..."
        handleSuccess={() =>
          handleSuccess({ [formValue]: () => <div>Submissions have finished</div> }, formValue)
        }
      />
    ),
    onComplete: refresh_child_submissions,
  },
]

const TopSectionStyle = ({ children }) => (
  <div className="Submissions_TopSection TopSection">
    <div className="Submissions_TopSectionContainer">{children}</div>
  </div>
)

const SubmissionsForWeek = ({ refresh_child_submissions, start_date, service_id, record }) => {
  const Actions = recordActionsToDisplay({
    actionsForRecord: actionsForRecord({
      refresh_child_submissions,
      start_date,
      service_id,
    }),
  })

  return hasAvailableAction(record, 'submissions_for_week') ? <Actions /> : null
}

const TopSection = ({ embedded, refresh_child_submissions, start_date, service_id, record }) =>
  embedded ? (
    <TopSectionStyle>
      <ActiveFilterToggles />
      <SubmissionsForWeek
        refresh_child_submissions={refresh_child_submissions}
        service_id={service_id}
        start_date={start_date}
        record={record}
      />
    </TopSectionStyle>
  ) : (
    <TopSectionStyle>
      <SubmissionsForWeek
        refresh_child_submissions={refresh_child_submissions}
        service_id={service_id}
        start_date={start_date}
        record={record}
      />
    </TopSectionStyle>
  )

export class SessionSummaries extends Component {
  render() {
    const {
      report,
      base_url,
      start_date,
      id,
      record_type,
      embedded,
      refresh_report,
      refresh_child_submissions
    } = this.props
    return (
      <Card
        embedded={embedded}
        title={
          <ActiveFilterToggles>
            <RegHolderName />
          </ActiveFilterToggles>
        }
      >
        <ExpiryMessage service_id={id}/>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <ForceSyncButton
            regHolder={getRegHolder(base_url, id)}
            start_date={moment(start_date).format('YYYY-MM-DD')}
            onComplete={() => {
              refresh_report(
                apiEndPoint({
                  record_type,
                  id,
                  start_date
                })
              )}
            }
          />
          <TopSection
            embedded={embedded}
            refresh_child_submissions={refresh_child_submissions}
            record={report.data}
            service_id={id}
            start_date={start_date}
          />
        </div>
        <NavigateByWeek
          base_url={base_url}
          start_date={start_date}
          view_type="Submissions"
        />
        <ActiveFilter
          records={report.data.session_summaries || []}
          filterOn={activeChild}
        >
          <List
            base_url={`${base_url}/${dayFormat(start_date)}`}
            className="submissionsList"
            loading={report.loading}
            listComponent={SessionSummariesList}
            detailComponent={props => (
              <SessionSummary
                {...props}
                service_id={id}
                service_type={record_type}
                start_date={start_date}
              />
            )}
            emptyComponent={NoSubmissions}
            filterOn={filterShape}
            idField="child_id"
          />
        </ActiveFilter>
      </Card>
    )
  }
}

export default LocalAsyncStore('report', SessionSummaries, apiEndPoint)



// WEBPACK FOOTER //
// ./src/session-summaries/container.js